<h1 mat-dialog-title>
  <ng-container i18n="Contest Task Clone Select Moda|Contest Task Clone Select Moda title@@contest-clone-tasks-select-modal-title">
    Copy Contest Tasks
  </ng-container>
</h1>
<div mat-dialog-content #dialogContent class="full-width details-content">
  <p *ngIf="contest && contest.name" class="contest-name">{{contest.name}}</p>
  <p i18n="Contest Task Clone Select Moda|Contest Direct URL details@@contest-clone-tasks-select-details">
    Please select one of the contests to copy tasks from it. Please note that this action will replace any existing tasks for the contest.
  </p>
  <p class="mat-body-strong contest-url">
    <contest-select *ngIf="competitionId"
                    class="full-width"
                    [competitionId]="competitionId"
                    (selected)="contestSelected($event)"></contest-select>
  </p>
</div>
<div mat-dialog-actions>
  <app-button [disabled]="inProgress"
              (clicked)="closeModal()"
              [secondary]="true"
              label="Cancel"
              i18n-label="General|Cancel action label@@general-cancel-action-label"></app-button>
  <span class="btn-spacer"></span>
  <app-button [disabled]="inProgress || !proceedAllowed()"
              (clicked)="proceed()"
              label="Copy"
              i18n-label="General|Copy action label@@general-copy-action-label"></app-button>
</div>
